export default __webpack_public_path__ + "static/media/beeftrader-logo-regular.31210223.svg";